import { CurrentUser } from "../types/User";

export function DoesUserHaveRole(
  user: CurrentUser | undefined,
  roles: string | string[]
): boolean {
  if (user) {
    let hasRole = false;

    if (typeof roles === "string") {
      return user.roles.includes(roles);
    } else {
      roles.forEach((role) => {
        if (user.roles.includes(role)) {
          hasRole = true;
        }
      });
      return hasRole;
    }
  } else {
    return false;
  }
}
